<template>
	<div class="tpl search-wrap">
		<div class="search-btn">
			<img src="../../assets/img/finds/ic_text_search@2x.png"/>
			<span>{{searchTitle}}</span>
		</div>
		<router-link tag="div" class="add-btn" :to="{name:'choose-address',params:{nowAdd:address}}">
			<img src="../../assets/img/finds/ic_nav_dingwei@2x.png"/>
			<span>{{address}}</span>
		</router-link>
	</div>
</template>

<script>
	export default{
		name:"header-search-add",
		props:["searchTitle","address"],
		created(){
			console.log(this.address)
		}
	}
</script>

<style scoped>
	.search-wrap{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 1rem 0.5rem;
	}
	.search-btn,.add-btn{
		display: flex;
		align-items: center;
		font-size: 0.65rem;
	}
	.search-btn img,.add-btn img{
		width: 2rem;
	}
	.search-btn{
		flex: 1;
		background: rgba(255,255,255,.1);
		padding: 0 0.5rem;
		border-radius: 3rem;
		color: rgba(255,255,255,.4);
	}
	.add-btn{
		color: #fff;
	}
	
</style>


// WEBPACK FOOTER //
// src/components/Common/HeaderSearchAdd.vue